// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.try {
  background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);
  padding-bottom: 35px;
}

.try__container {
  width: 100%;
  margin: 0 auto;
  max-width: 735px;
  height: 100%;
  flex-direction: column;
  display: flex;
  @media screen and (max-width: 600px) {
    padding-top: 80px;
    
  } 
}

.try__title {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 36px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 47px;
  text-align: center;
}
.try__text {
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 14px;
  letter-spacing: 0;
  line-height: 30px;
}
.try__input {
  margin-top: 12px;
  display: flex;
  width: 100%;
  @media screen and (max-width: 600px) {
   flex-direction: column;
  } 
}
.try__search {
  display: flex;
  box-sizing: border-box;
  border: 1px solid #979797;
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 18px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 24px;
  width: 100%;
  padding: 12px 24px;
  @media screen and (max-width: 600px) {
   height: 50px;
  
   } 
}
.try__search:focus {
  outline: none;
}
.try__button {
  display: flex;
  margin-left: 14px;
  background-color: #fa332a;
  height: 50px;
  width: 134px;
  color: #ffffff;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 21px;
  border: none;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 600px) {
    margin-left: 0;
    margin-top: 20px;
   } 
}
@media screen and (max-width: 600px) {
  .try__btn-wrap{
    width: 100%;
    display: flex;
    justify-content: center;
  }
  
 } 
.try__result {
  margin-top: 24px;
  color: #1e1c1a;
  font-family: Roboto;
  font-size: 18px;
  font-weight: bold;
  letter-spacing: 0;
  line-height: 30px;
  text-align: left;
}
.try__btn {
  display: flex;
  justify-content: center;
}
.try__show {
  height: 36px;
  width: 242px;
  background-color: #1e1c1a;
  color: #ffffff;
  font-family: Roboto;
  font-size: 14px;
  font-weight: 500;
  letter-spacing: 0;
  line-height: 16px;
  border: none;
  margin-top: 35px;
}
`, "",{"version":3,"sources":["webpack://./src/components/TryIt/TryIt.css"],"names":[],"mappings":"AAAA;EACE,iFAAiF;EACjF,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,sBAAsB;EACtB,aAAa;EACb;IACE,iBAAiB;;EAEnB;AACF;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,kBAAkB;AACpB;AACA;EACE,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX;GACC,sBAAsB;EACvB;AACF;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,WAAW;EACX,kBAAkB;EAClB;GACC,YAAY;;GAEZ;AACH;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,iBAAiB;EACjB,yBAAyB;EACzB,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,uBAAuB;EACvB,mBAAmB;EACnB;IACE,cAAc;IACd,gBAAgB;GACjB;AACH;AACA;EACE;IACE,WAAW;IACX,aAAa;IACb,uBAAuB;EACzB;;CAED;AACD;EACE,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,uBAAuB;AACzB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,cAAc;EACd,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,gBAAgB;AAClB","sourcesContent":[".try {\n  background-image: url(https://www.zazmic.com/wp-content/themes/zazmic/img/bg.png);\n  padding-bottom: 35px;\n}\n\n.try__container {\n  width: 100%;\n  margin: 0 auto;\n  max-width: 735px;\n  height: 100%;\n  flex-direction: column;\n  display: flex;\n  @media screen and (max-width: 600px) {\n    padding-top: 80px;\n    \n  } \n}\n\n.try__title {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 36px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 47px;\n  text-align: center;\n}\n.try__text {\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 14px;\n  letter-spacing: 0;\n  line-height: 30px;\n}\n.try__input {\n  margin-top: 12px;\n  display: flex;\n  width: 100%;\n  @media screen and (max-width: 600px) {\n   flex-direction: column;\n  } \n}\n.try__search {\n  display: flex;\n  box-sizing: border-box;\n  border: 1px solid #979797;\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 24px;\n  width: 100%;\n  padding: 12px 24px;\n  @media screen and (max-width: 600px) {\n   height: 50px;\n  \n   } \n}\n.try__search:focus {\n  outline: none;\n}\n.try__button {\n  display: flex;\n  margin-left: 14px;\n  background-color: #fa332a;\n  height: 50px;\n  width: 134px;\n  color: #ffffff;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 21px;\n  border: none;\n  justify-content: center;\n  align-items: center;\n  @media screen and (max-width: 600px) {\n    margin-left: 0;\n    margin-top: 20px;\n   } \n}\n@media screen and (max-width: 600px) {\n  .try__btn-wrap{\n    width: 100%;\n    display: flex;\n    justify-content: center;\n  }\n  \n } \n.try__result {\n  margin-top: 24px;\n  color: #1e1c1a;\n  font-family: Roboto;\n  font-size: 18px;\n  font-weight: bold;\n  letter-spacing: 0;\n  line-height: 30px;\n  text-align: left;\n}\n.try__btn {\n  display: flex;\n  justify-content: center;\n}\n.try__show {\n  height: 36px;\n  width: 242px;\n  background-color: #1e1c1a;\n  color: #ffffff;\n  font-family: Roboto;\n  font-size: 14px;\n  font-weight: 500;\n  letter-spacing: 0;\n  line-height: 16px;\n  border: none;\n  margin-top: 35px;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
